import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { AssetService } from '../../models/assetservice.class';
import { CommonUtilsService } from '../../services/commonutils/common-utils.service';
import { FetchAssetsModalComponent } from '../fetch-assets-modal/fetch-assets-modal.component';
import { getApp$ } from '../../store/selectors/apps.selector';
import { GetAssetWithLatestVersion, SetSelectedAppRestApiName } from '../../store/actions/apps.actions';
import { getSelectedCategory$ } from '../../store/selectors/shared.selector';

import { AppProcessesSelectionDirective } from '../../directives/app-processes/app-processes.directive';
import { SharedState } from '../../store/states';
import { RootScope } from '@eninvoice-core/services/rootscope';

@Component({
    selector: 'app-left-nav-apps-template',
    templateUrl: './left-nav-apps-template.component.html',
    styleUrls: ['./left-nav-apps-template.component.scss'],
    providers: [AppProcessesSelectionDirective],
    standalone: false,
})
export class LeftNavAppsTemplateComponent implements OnInit, OnDestroy {
    @Input() serviceId: string;
    @Input() package: {
        serviceId?: string;
        name: string;
        id: string;
        src: string;
        srcHover: string;
        apps: {
            order: number;
            serviceId: string;
            displayName: string;
            restApiName: string;
        }[];
        groups: {
            id: string;
            order: number;
        }[];
    };
    @Input() selectedLeftNav: SharedState['leftNavMap'][0];

    @Output() closeMenu = new EventEmitter();
    @Output() bridgeDialogOpen = new EventEmitter<boolean>();

    public app: AssetService;
    private unsubscribe = new Subject<void>();
    public isNewUI: boolean = this._commonUtils.getCookie('new-ui') === 'true' ? true : false;
    activeCategory: string;

    constructor(
        private store$: Store,
        private _allProcesses: AppProcessesSelectionDirective,
        private dialog: MatDialog,
        private _commonUtils: CommonUtilsService,
        private R: RootScope
    ) {}

    selectionEvent = () => {
        this.closeMenu.emit();
        this.R.clearCurrentAssetData();
        this.R.currentInstanceId.next(undefined);
        this.store$.dispatch(SetSelectedAppRestApiName({ restApiName: this.app.restApiName }));
        this._allProcesses.app = this.app;
        this._allProcesses.onAppSelection();
    };

    public fetchBridgeAssets = (app: AssetService) => {
        this.store$.dispatch(GetAssetWithLatestVersion({ serviceId: app?.serviceId }));
        this.bridgeDialogOpen.emit(true);
        const dialog = this.dialog.open(FetchAssetsModalComponent, {
            panelClass: ['fetchAssetModalParent', 'subscribeAssetModal'],
            disableClose: true,
        });
        dialog.componentInstance.appServiceId = app.serviceId;
        dialog.componentInstance.appAssetId = app.assetMetaUId;
        dialog.afterClosed().subscribe(() => {
            this.bridgeDialogOpen.emit(false);
            this.closeMenu.emit();
        });
    };

    public trackById = (index, item) => {
        return item?.id || item?.serviceId || index;
    };

    ngOnInit(): void {
        this.serviceId &&
            this.store$
                .select(getApp$(this.serviceId))
                .pipe(takeUntil(this.unsubscribe))
                .subscribe(event => {
                    this.app = CommonUtilsService.cloneObject(event);
                });
        this.store$
            .select(getSelectedCategory$)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(event => {
                this.activeCategory = event;
            });
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
